import { styled } from '@mui/material';

const Footer = styled('div')(() => ({
  boxSizing: 'border-box',
  padding: '8px 14px calc(8px + env(safe-area-inset-bottom))',
  backgroundColor: 'white',
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  zIndex: 1200,
  borderTop: '1px solid rgba(83, 74, 183, 0.16)',
  boxShadow: '0 -10px 28px rgba(15, 23, 42, 0.08)',
  display: 'flex',
  justifyContent: 'center',
  height: 'calc(72px + env(safe-area-inset-bottom))',
}));
export default Footer;
